import { useEffect, useState } from 'react';

/**
 * True when the primary pointer can hover (mouse/trackpad), false on touch
 * devices (phones, tablets). Use to gate hover-only interactions so that on
 * touch they don't fight with tap/click handlers.
 */
export const useHasHover = () => {
  const query = '(hover: hover) and (pointer: fine)';
  const [hasHover, setHasHover] = useState<boolean>(
    typeof window !== 'undefined' && 'matchMedia' in window
      ? window.matchMedia(query).matches
      : true,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return;
    const mql = window.matchMedia(query);
    const handleChange = (e: MediaQueryListEvent) => setHasHover(e.matches);
    mql.addEventListener('change', handleChange);
    return () => mql.removeEventListener('change', handleChange);
  }, []);

  return hasHover;
};
